import { Common } from '../common';
import {
  Scheme,
  SchemeListEntry,
  SchemeFull,
  SchemeWithConfigs,
  CreateValues,
  CloneValues,
  CloneResponse,
  UpdateValues,
  FindAllOptions,
  PreviewOptions,
  PreviewEntityParams,
  PreviewMessage,
  PreviewEntityKind,
} from '../models/notification/scheme';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(options?: FindAllOptions): Promise<Scheme[]> {
    const url = this.common.constructPath(`/notification-schemes`, options);
    return this.common.getJSON(url);
  }

  async findAllForList(options?: FindAllOptions): Promise<SchemeListEntry[]> {
    const url = this.common.constructPath(
      `/notification-schemes/list`,
      options,
    );
    return this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<SchemeFull> {
    const url = this.common.constructPath(`/notification-schemes/${id}`);
    return this.common.getJSON(url);
  }

  async preview(
    id: string,
    entity: PreviewEntityParams,
  ): Promise<PreviewMessage[]> {
    let query: PreviewOptions;
    if (entity.entityKind === PreviewEntityKind.Encounter) {
      query = { encounterId: entity.entityId };
    } else {
      query = { ehrInformationId: entity.entityId };
    }
    const url = this.common.constructPath(
      `/notification-schemes/${id}/preview`,
      query,
    );
    return this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<SchemeWithConfigs> {
    const url = this.common.constructPath(`/notification-schemes`);
    return this.common.postJSON(url, values);
  }

  async clone(id: string, values: CloneValues): Promise<CloneResponse> {
    const url = this.common.constructPath(`/notification-schemes/${id}/clone`);
    return this.common.postJSON(url, values);
  }

  async update(id: string, values: UpdateValues): Promise<SchemeWithConfigs> {
    const url = this.common.constructPath(`/notification-schemes/${id}`);
    return this.common.patchJSON(url, values);
  }

  async remove(id: string): Promise<{ success: true }> {
    const url = this.common.constructPath(`/notification-schemes/${id}`);
    return this.common.deleteJSON(url);
  }
}
